// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
// 引入路由
import router from './router';
// 引入状态管理
import store from './vuex/store';
// 引入icon
import './assets/icon/iconfont.css'
// 

// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import axios from 'axios';
Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

// 使用element UI
Vue.use(ElementUI);

import * as custom from './utils/util'
import { req } from './api/axiosFun';
Object.keys(custom).forEach(key => {
    // 全局过滤器 
    Vue.filter(key, custom[key]);
})

// 路由拦截器
router.beforeEach((to, from, next) => {
    if (to.matched.length != 0) {
        if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
            if (Boolean(localStorage.getItem("userInfo"))) { // 通过vuex state获取当前的user是否存在
                next();
            } else {
                next({
                    path: '/login',
                    query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                })
            }
        } else {
            if (Boolean(localStorage.getItem("userInfo"))) { // 判断是否登录
                if (to.path != "/" && to.path != "/login") { //判断是否要跳到登录界面
                    next();
                } else {
                    /**
                     * 防刷新，如果登录，修改路由跳转到登录页面，修改路由为登录后的首页 
                     */
                    next({
                        path: '/pay/Data'
                    })
                }
            } else {
                next();
            }
        }
    } else {
        next({
            path: '/login',
            query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
    }
})

// 这里拦截302错误，并重新跳入登页重新获取token
axios.interceptors.response.use(
    response => {
        if (response.data && response.data.code === 302) {
            store.commit('logout', 'false')
            router.push({ path: '/login' })
        } else {
            const res = response.data;
            if (null != res.success && !res.success) {
                Vue.prototype.$message({
                    type: 'error',
                    message: res.msg,
                });
                return null;
            } else {
                return res;
            }
        }
    }, error => {
        if (error.response) {
            //请求异常
        }
        return Promise.reject(error.response.data)
    }
);
//请求拦截器 增加token
axios.interceptors.request.use(
    request => {
        //接受JSON数据格式
        request.headers['Content-Type'] = 'application/json;charset=utf-8';
        // 设置请求头
        request.headers['token'] = localStorage.getItem('logintoken');
        return request;
    }, error => {
        if (error.request) {
            //请求异常
        }
        return Promise.reject(error)
    }
);


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store, //使用store vuex状态管理
    components: { App },
    template: '<App/>',
    data: {
        // 空的实例放到根组件下，所有的子组件都能调用
        Bus: new Vue()
    }

})


// WEBPACK FOOTER //
// ./src/main.js